<template>
  <div>Customer Complete Profile</div>
</template>

<script>
export default {};
</script>

<style>
</style>